import { useLayoutEffect, useEffect,  useRef, useState } from "react";
import gsap from "gsap";
import GetInTouch from "../components/gettouch";
import { ScrollTrigger } from "gsap/ScrollTrigger";



// // Components

import ServicesCards from "../components/card-services";

// Videos
import video from "../assets/image/Home/modernpoultryprocessing.mp4"

// Images 
// specialise
// import icon01 from "../assets/image/Home/icons/home/End-to-end-FoodSafe-Portfolio.png"
// import icon02 from "../assets/image/Home/icons/home/Hygienic-design-at-the-core.png"
// import icon03 from "../assets/image/Home/icons/home/Proven-poultry-processing-expertise-.png"
// import icon04 from "../assets/image/Home/icons/home/Global-technology.png"
// import icon05 from "../assets/image/Home/icons/home/Continuous-improvement-focus.png"

// clients
import client01 from "../assets/image/Home/clients/Shanthi-chicken.png"
import client02 from "../assets/image/Home/clients/Pragathi.png"
import client03 from "../assets/image/Home/clients/Sneha.png"
import client04 from "../assets/image/Home/clients/Kwality.png"
import client05 from "../assets/image/Home/clients/Subhiksha.png"
import client06 from "../assets/image/Home/clients/osi.png"
import client07 from "../assets/image/Home/clients/perfetti-van-melle.png"
import client08 from "../assets/image/Home/clients/bimbo.png"
import client09 from "../assets/image/Home/clients/ID.png"
// import client09 from "../assets/image/Home/clients/Kwality.png"


// iso
// import iso01 from "../assets/image/Home/Profit"

import trust00 from "../assets/image/Trusted/Trusted.png"
import trust01 from "../assets/image/Trusted/engineering-assembly.png"
import trust02 from "../assets/image/Trusted/India-map.png"
import trust03 from "../assets/image/Trusted/Hygienic-Design.png"
import trust04 from "../assets/image/Trusted/France.png"
import trust05 from "../assets/image/Trusted/Brazil.png"
import trust06 from "../assets/image/Trusted/Thailand.png"
import trust07 from "../assets/image/Trusted/Belgium.png"
import trust08 from "../assets/image/Trusted/Hygienic-Desigin-Conveyor.png"
import trust09 from "../assets/image/Trusted/Hen.png"
import trust10 from "../assets/image/Trusted/Partnerships.png"



gsap.registerPlugin(ScrollTrigger);

const Clients = [
    {
     src:client01,
     name:"shanthi Chicken"
    },
    {
     src:client02,
     name:"Pragathi"
    },
    {
     src:client03,
     name:"sneha"
    },
    {
     src:client04,
     name:"Belchick"
    },
    {
     src:client05,
     name:"Subhiksha"
    },
    {
     src:client06,
     name:"OSI"
    },
    {
     src:client07,
     name:"Perfetti"
    },
    {
     src:client08,
     name:"Bimbo"
    },
    {
     src:client09,
     name:"ID"
    },

]

const FAQS = [

{
q:"What does PthruP do?",
a:"PthruP designs and delivers hygienic conveyor systems, integrated poultry processing lines, and FoodSafe infrastructure. We also provide consulting for plant layout, sanitation programs, and digital food safety management."
},
{
q:"Which industries does PthruP serve?",
a:"PthruP primarily serves poultry processing plants and food manufacturers, including ready meals (RTE/RTC), meat, and seafood processors."
},
{
q:"Can PthruP upgrade an existing plant or only build new lines?",
a:"PthruP supports both greenfield and brownfield projects, from incremental conveyor upgrades and sanitation improvements to full line redesign and plant automation.​​"
},
{
q:"How does PthruP improve food safety?",
a:"We apply hygienic design principles, supply easy-to-clean conveyors and structures, and support sanitation programs, audits, and digital food safety systems to reduce contamination risks and improve regulatory compliance."
},
{
q:"Where is PthruP based and where does it operate?",
a:"PthruP is headquartered in Peenya, Bengaluru, and serves food processing customers across India, Sri Lanka, South East Asia and the Middle East"
},
{
q:"Does PthruP offer turnkey poultry processing solutions?",
a:"Yes. PthruP provides end-to-end poultry processing solutions, including consulting, layout design, conveyors, integrated equipment, installation support, and post-commissioning assistance."

},
{
q:"What makes PthruP’s conveyors different?",
a:"PthruP’s FoodSafe conveyors are engineered for hygiene, durability, and ease of cleaning, using compatible materials, minimal fasteners, and hygienic design standards aligned with global best practices."
},
{
q:"Can PthruP support high-capacity processing plants?",
a:"Yes. PthruP has proven experience supporting high-throughput poultry and food processing plants, delivering systems designed for continuous operation, reliability, and scalability."
},
{

q:"Does PthruP provide after-sales service and maintenance support?",
a:"Yes. We offer maintenance guidance, spare parts support, system health checks, and long-term service options to ensure sustained performance and uptime."
},
{
q:"Does PthruP work with global technology partners?",
a:"Yes. PthruP collaborates with leading global technology and hygiene partners while delivering solutions tailored for Indian operating conditions."
},

];

export default function Home() {


  const trackRef = useRef(null);

  useEffect(() => {
    const track = trackRef.current;
    const items = gsap.utils.toArray(".marq-item-logo");

    // Duplicate content for seamless loop
    items.forEach((item) => {
      const clone = item.cloneNode(true);
      track.appendChild(clone);
    });

    const totalWidth = track.scrollWidth / 2;

    let speed = 100; // px per second (adjust speed here)

    const tween = gsap.to(track, {
      x: `-=${totalWidth}`,
      duration: totalWidth / speed,
      ease: "none",
      repeat: -1,
    });

    // 🔥 Hover Pause
    track.addEventListener("mouseenter", () => tween.pause());
    track.addEventListener("mouseleave", () => tween.resume());

    // 🔥 Touch / Drag Support
    let isDown = false;
    let startX;
    let currentX = 0;

    const onDown = (e) => {
      isDown = true;
      tween.pause();
      startX = e.pageX || e.touches[0].pageX;
    };

    const onMove = (e) => {
      if (!isDown) return;
      const x = e.pageX || e.touches[0].pageX;
      const walk = x - startX;

      currentX += walk;
      gsap.set(track, { x: `+=${walk}` });

      startX = x;
    };

    const onUp = () => {
      isDown = false;
      tween.resume();
    };

    track.addEventListener("mousedown", onDown);
    track.addEventListener("mousemove", onMove);
    track.addEventListener("mouseup", onUp);
    track.addEventListener("mouseleave", onUp);

    track.addEventListener("touchstart", onDown);
    track.addEventListener("touchmove", onMove);
    track.addEventListener("touchend", onUp);

    return () => {
      tween.kill();
    };
  }, []);

  const heroRef = useRef();

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {


        const rows = gsap.utils.toArray(".h1-s-wrap");

rows.forEach((row, i) => {
  const direction = i % 2 === 0 ? -1 : 1;   // alternate direction
  const distance = 40 - i * 10;             // depth (40, 30, 20)

  gsap.to(row, {
    x: direction * distance,
    ease: "none",
    scrollTrigger: {
      trigger: heroRef.current,
      start: "top bottom",
      end: "bottom top",
      scrub: 1.2
    }
  });
});
      // HEADINGS SLIDE ANIMATION
      gsap.from(".is-h-wrap-1", { x: "12em", duration: 1.2, ease: "power3.out" });
      gsap.from(".is-h-wrap-2", { x: "6em", duration: 1.2, delay: 0.1, ease: "power3.out" });
      gsap.from(".is-h-wrap-3", { y: 60, opacity: 0, duration: 1, delay: 0.2 });
      gsap.from(".is-h-wrap-4", { x: "-6em", duration: 1.2, delay: 0.3, ease: "power3.out" });
      gsap.from(".is-h-wrap-5", { x: "-12em", duration: 1.2, delay: 0.4, ease: "power3.out" });
      gsap.from(".is-h-wrap-6", { x: "-6em", duration: 1.2, delay: 0.5, ease: "power3.out" });



      // DASH GROW ANIMATION
      gsap.from(".dash", {
        width: 0,
        duration: 1.2,
        delay: 0.6,
        ease: "power2.out"
      });

      // HERO VIDEO FADE IN
      gsap.from(".home-hero-video", {
        opacity: 0,
        scale: 1.1,
        duration: 1.4,
        delay: 0.7,
        ease: "power2.out"
      });

      // MARQUEE INFINITE SCROLL
      gsap.to(".hero-img-track", {
        xPercent: -50,
        ease: "none",
        duration: 20,
        repeat: -1
      });

    }, heroRef);

    return () => ctx.revert();
  }, []);

  const aboutRef = useRef();

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {

      // ROWS PARALLAX (subtle horizontal drift)
      gsap.from(".is-row-1", {
        xPercent: 4,
        scrollTrigger: {
          trigger: ".is-row-1",
          start: "top 85%",
          scrub: 1
        }
      });

      gsap.from(".is-row-2", {
        xPercent: 2,
        scrollTrigger: {
          trigger: ".is-row-2",
          start: "top 85%",
          scrub: 1
        }
      });

      gsap.from(".is-row-3", {
        xPercent: -2,
        scrollTrigger: {
          trigger: ".is-row-3",
          start: "top 85%",
          scrub: 1
        }
      });

      gsap.from(".is-row-4", {
        xPercent: 2,
        scrollTrigger: {
          trigger: ".is-row-4",
          start: "top 85%",
          scrub: 1
        }
      });

      // TEXT REVEAL (up & down alternating)
      gsap.from(".h2", {
        y: -120,
        opacity: 0,
        duration: 1,
        stagger: 0.15,
        scrollTrigger: {
          trigger: aboutRef.current,
          start: "top 75%"
        }
      });

      gsap.from(".h2-stroke", {
        y: 120,
        opacity: 0,
        duration: 1,
        stagger: 0.15,
        scrollTrigger: {
          trigger: aboutRef.current,
          start: "top 75%"
        }
      });

      // UNDERLINE GROW
      gsap.from(".h-underline", {
        width: 0,
        duration: 1.4,
        ease: "power3.out",
        scrollTrigger: {
          trigger: ".h-underline",
          start: "top 85%"
        }
      });

    }, aboutRef);

    return () => ctx.revert();
  }, []);

  const specialiseRef = useRef();

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {

      // ROWS PARALLAX (subtle horizontal drift)
      gsap.from(".is-row-1", {
        xPercent: 4,
        scrollTrigger: {
          trigger: ".is-row-1",
          start: "top 85%",
          scrub: 1
        }
      });

      gsap.from(".is-row-2", {
        xPercent: 2,
        scrollTrigger: {
          trigger: ".is-row-2",
          start: "top 85%",
          scrub: 1
        }
      });

      gsap.from(".is-row-3", {
        xPercent: -2,
        scrollTrigger: {
          trigger: ".is-row-3",
          start: "top 85%",
          scrub: 1
        }
      });

      gsap.from(".is-row-4", {
        xPercent: 2,
        scrollTrigger: {
          trigger: ".is-row-4",
          start: "top 85%",
          scrub: 1
        }
      });

      // TEXT REVEAL (up & down alternating)
      gsap.from(".h2", {
        y: -120,
        opacity: 0,
        duration: 1,
        stagger: 0.15,
        scrollTrigger: {
          trigger: specialiseRef.current,
          start: "top 75%"
        }
      });

      gsap.from(".h2-stroke", {
        y: 120,
        opacity: 0,
        duration: 1,
        stagger: 0.15,
        scrollTrigger: {
          trigger: specialiseRef.current,
          start: "top 75%"
        }
      });

gsap.from(".sm-anim-wrapper", {
  x: -120,
  opacity: 0,
  duration: 1,
   stagger: 0.15,
  ease: "none",
  scrollTrigger: {
    trigger: ".h-scroll-card",
    start: "top 85%",   
    toggleActions: "play none none none"
  }
});

    }, specialiseRef);

    return () => ctx.revert();
  }, []);


  const leadingRef = useRef();
 
  useLayoutEffect(() => {
    const ctx = gsap.context(() => {

      // ROWS PARALLAX (subtle horizontal drift)
      gsap.from(".is-row-1", {
        xPercent: 4,
        scrollTrigger: {
          trigger: ".is-row-1",
          start: "top 85%",
          scrub: 1
        }
      });

      gsap.from(".is-row-2", {
        xPercent: 2,
        scrollTrigger: {
          trigger: ".is-row-2",
          start: "top 85%",
          scrub: 1
        }
      });

      gsap.from(".is-row-3", {
        xPercent: -2,
        scrollTrigger: {
          trigger: ".is-row-3",
          start: "top 85%",
          scrub: 1
        }
      });

      gsap.from(".is-row-4", {
        xPercent: 2,
        scrollTrigger: {
          trigger: ".is-row-4",
          start: "top 85%",
          scrub: 1
        }
      });

      // TEXT REVEAL (up & down alternating)
      gsap.from(".h2", {
        y: -120,
        opacity: 0,
        duration: 1,
        stagger: 0.15,
        scrollTrigger: {
          trigger: leadingRef.current,
          start: "top 75%"
        }
      });

      gsap.from(".h2-stroke", {
        y: 120,
        opacity: 0,
        duration: 1,
        stagger: 0.15,
        scrollTrigger: {
          trigger: leadingRef.current,
          start: "top 75%"
        }
      });


      
gsap.from(".h-scroll", {
  y: 120,
  opacity: 0,
  duration: 0.6,
     stagger: 0.15,
  ease: "power3.out",
  scrollTrigger: {
    trigger: ".h-scroll-card",
    start: "top 85%",   
    toggleActions: "play none none none"
  }
});

    }, leadingRef);

    return () => ctx.revert();
  }, []);




  const serviceRef = useRef();

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      const rows = gsap.utils.toArray(".h-row");

      rows.forEach((row, i) => {
        gsap.from(row.children, {
          yPercent: 100,
          opacity: 0,
          duration: 1,
          stagger: 0.15,
          ease: "power4.out",
          scrollTrigger: {
            trigger: row,
            start: "top 85%",
          },
        });
      });

       gsap.from(".text-reveal", {
        opacity: 0,
        y: 60,
        duration: 1,
        ease: "power3.out",
        scrollTrigger: {
          trigger: ref.current,
          start: "top 85%",
        },
      });


       // ROWS PARALLAX (subtle horizontal drift)
      gsap.from(".is-row-1", {
        xPercent: 4,
        scrollTrigger: {
          trigger: ".is-row-1",
          start: "top 85%",
          scrub: 1
        }
      });

      gsap.from(".is-row-2", {
        xPercent: 2,
        scrollTrigger: {
          trigger: ".is-row-2",
          start: "top 85%",
          scrub: 1
        }
      });

      gsap.from(".is-row-3", {
        xPercent: -2,
        scrollTrigger: {
          trigger: ".is-row-3",
          start: "top 85%",
          scrub: 1
        }
      });

      gsap.from(".is-row-4", {
        xPercent: 2,
        scrollTrigger: {
          trigger: ".is-row-4",
          start: "top 85%",
          scrub: 1
        }
      });

      // TEXT REVEAL (up & down alternating)
      gsap.from(".h2", {
        y: -120,
        opacity: 0,
        duration: 1,
        stagger: 0.15,
        scrollTrigger: {
          trigger: serviceRef.current,
          start: "top 75%"
        }
      });

      gsap.from(".h2-stroke", {
        y: 120,
        opacity: 0,
        duration: 1,
        stagger: 0.15,
        scrollTrigger: {
          trigger: serviceRef.current,
          start: "top 75%"
        }
      });


    }, serviceRef );

    return () => ctx.revert();
  }, []);


  const sectionRef = useRef();
useLayoutEffect(() => {
  const ctx = gsap.context(() => {

    const mm = gsap.matchMedia();

    mm.add("(min-width: 768px)", () => {

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top top",
          end: "+=1500",
          scrub: true,
          // pin: true,
        }
      });

    tl.to(".is-left .ind-img.is-1", {
      height: 0,
      ease: "power2.out",
      duration: 1
    }, 0);

    tl.to(".is-right .ind-img.is-3", {
      height: 0,
      ease: "power2.out",
      duration: 1
    }, 0);

    tl.to(".ind-img", {
      scale: 1.08,
      ease: "none"
    }, 0);

    tl.to(".column .ind-swap-text.is-1", {
  opacity: 0,
  y: -20,
  stagger: 0.05
}, 0.2);

tl.fromTo(".column .ind-swap-text.is-2",
  { opacity: 0, y: 20 },
  { opacity: 1, y: 0, stagger: 0.05 },
  0.2
);

tl.to(".serv-no.is-1, .serv-no.is-2", {
  opacity: 0,
  y: -20,
  stagger: 0.05
}, 0.2);

tl.fromTo(".serv-no.is-3, .serv-no.is-4",
  { opacity: 0, y: 20 },
  { opacity: .6, y: 0, stagger: 0.05 },
  0.2
);


tl.to(".column.is-left", {
  xPercent: -100,
  ease: "power2.in"
}, 1.05);

tl.to(".column.is-right", {
  xPercent: 100,
  ease: "power2.in"
}, 1.05);

// FAST POP IN
tl.from(".surprise-column", {
  scale: .85,
  opacity: 0,
  ease: "power2.out",
  duration: 1.06
}, 1.06);

// IMAGE RISE (quick stagger)
tl.from(".emerge-img-wrap", {
  y: 20,
  // opacity: 0.6,
  ease: "power2.out",
  duration: 0.1,
  stagger: 0.08
}, 1.07);

// TEXT + BUTTON SNAP IN
tl.from(".h2-special, .h2-stroke, .btn", {
  y: 24,
  opacity: 0.6,
  ease: "power2.out",
  duration: 0.1,
  stagger: 0.06
}, 1.07);



tl.from(".eme-img-1", {
  y: -80,
  ease: "none",
  scrollTrigger: {
    trigger: sectionRef.current,
    scrub: true
  }
});

tl.from(".eme-img-2", {
  y: -80,
  ease: "none",
  scrollTrigger: {
    trigger: sectionRef.current,
    scrub: true
  }
});
    });


      mm.add("(max-width: 768px)", () => {

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top top",
          end: "+=1500",
          scrub: true,
          // pin: true,
        }
      });




    tl.to(".is-left .ind-img.is-1", {
      height: 0,
      ease: "power2.out",
      duration: 1
    }, 0);

    tl.to(".is-right .ind-img.is-3", {
      height: 0,
      ease: "power2.out",
      duration: 1
    }, 0);

    tl.to(".ind-img", {
      scale: 1.08,
      ease: "none"
    }, 0);

    tl.to(".column .ind-swap-text.is-1", {
  opacity: 0,
  y: -20,
  stagger: 0.05
}, 0.2);

tl.fromTo(".column .ind-swap-text.is-2",
  { opacity: 0, y: 20 },
  { opacity: 1, y: 0, stagger: 0.05 },
  0.2
);

tl.to(".serv-no.is-1, .serv-no.is-2", {
  opacity: 0,
  y: -20,
  stagger: 0.05
}, 0.2);

tl.fromTo(".serv-no.is-3, .serv-no.is-4",
  { opacity: 0, y: 20 },
  { opacity: .6, y: 0, stagger: 0.05 },
  0.2
);


tl.to(".column.is-left", {
  yPercent: -100,
  ease: "power2.in"
}, 1.05);

tl.to(".column.is-right", {
  yPercent: 100,
  ease: "power2.in"
}, 1.05);

// FAST POP IN
tl.from(".surprise-column", {
  scale: 0.85,
  opacity: 0,
  ease: "power2.out",
  duration: 0.2
}, 1.2);



      tl.from(".eme-img-1", {
  y: -80,
  ease: "none",
  scrollTrigger: {
    trigger: sectionRef.current,
    scrub: true
  }
});

tl.from(".eme-img-2", {
  y: -80,
  ease: "none",
  scrollTrigger: {
    trigger: sectionRef.current,
    scrub: true
  }
});

    });




  }, sectionRef);

  return () => ctx.revert();
}, []);



  const ref = useRef();

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      const rows = gsap.utils.toArray(".h-row");

      rows.forEach((row, i) => {
        gsap.from(row.children, {
          yPercent: 100,
          opacity: 0,
          duration: 1,
          stagger: 0.15,
          ease: "power4.out",
          scrollTrigger: {
            trigger: row,
            start: "top 85%",
          },
        });
      });
    }, ref);

    return () => ctx.revert();
  }, []);


  const industriesRef = useRef(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      // ROWS PARALLAX (subtle horizontal drift)
      gsap.from(".is-row-1", {
        xPercent: 4,
        scrollTrigger: {
          trigger: ".is-row-1",
          start: "top 85%",
          scrub: 1
        }
      });

      gsap.from(".is-row-2", {
        xPercent: 2,
        scrollTrigger: {
          trigger: ".is-row-2",
          start: "top 85%",
          scrub: 1
        }
      });

      gsap.from(".is-row-3", {
        xPercent: -2,
        scrollTrigger: {
          trigger: ".is-row-3",
          start: "top 85%",
          scrub: 1
        }
      });

      gsap.from(".is-row-4", {
        xPercent: 2,
        scrollTrigger: {
          trigger: ".is-row-4",
          start: "top 85%",
          scrub: 1
        }
      });

      // TEXT REVEAL (up & down alternating)
      gsap.from(".h2", {
        y: -120,
        opacity: 0,
        duration: 1,
        stagger: 0.15,
        scrollTrigger: {
          trigger: industriesRef.current,
          start: "top 75%"
        }
      });

      gsap.from(".h2-stroke", {
        y: 120,
        opacity: 0,
        duration: 1,
        stagger: 0.15,
        scrollTrigger: {
          trigger: industriesRef.current,
          start: "top 75%"
        }
      });

    }, industriesRef);

    return () => ctx.revert();
  }, []);


const logoRef = useRef(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {


      gsap.from(".logo-heading .h2, .logo-heading .h2-stroke", {
        y: 0,
        opacity: 0,
        stagger: 0.1,
        duration: 1,
        ease: "power3.out",
        scrollTrigger: {
          trigger: logoRef.current,
          start: "top 80%"
        }
      });

   
      gsap.from(".logo-description", {
        opacity: 0,
        y: 40,
        duration: 1,
        scrollTrigger: {
          trigger: logoRef.current,
          start: "top 85%"
        }
      });

 
      gsap.from(".logo-card", {
        y: 80,
        opacity: 0,
        stagger: 0.05,
        duration: 2,
        ease: "power2.out",
        scrollTrigger: {
      trigger: '.logo-card',
          start: "top 85%"
        }
      });

       // ROWS PARALLAX (subtle horizontal drift)
      gsap.from(".is-row-1", {
        xPercent: 4,
        scrollTrigger: {
          trigger: ".is-row-1",
          start: "top 85%",
          scrub: 1
        }
      });

      gsap.from(".is-row-2", {
        xPercent: 2,
        scrollTrigger: {
          trigger: ".is-row-2",
          start: "top 85%",
          scrub: 1
        }
      });

      gsap.from(".is-row-3", {
        xPercent: -2,
        scrollTrigger: {
          trigger: ".is-row-3",
          start: "top 85%",
          scrub: 1
        }
      });

      gsap.from(".is-row-4", {
        xPercent: 2,
        scrollTrigger: {
          trigger: ".is-row-4",
          start: "top 85%",
          scrub: 1
        }
      });

      // TEXT REVEAL (up & down alternating)
      gsap.from(".h2", {
        y: -120,
        opacity: 0,
        duration: 1,
        stagger: 0.15,
        scrollTrigger: {
          trigger: aboutRef.current,
          start: "top 75%"
        }
      });

      gsap.from(".h2-stroke", {
        y: 120,
        opacity: 0,
        duration: 1,
        stagger: 0.15,
        scrollTrigger: {
          trigger: aboutRef.current,
          start: "top 75%"
        }
      });


    }, logoRef);

    return () => ctx.revert();
  }, []);

 const bannerRef = useRef(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {

   
      gsap.from(".bn-img.is-1", {
        y: -250,
        scrollTrigger: {
          trigger: bannerRef.current,
          start: "top bottom",
          scrub: true
        }
      });

      gsap.from(".bn-img.is-2", {
        y: -250,
        scrollTrigger: {
          trigger: bannerRef.current,
          start: "top bottom",
          scrub: true
        }
      });


      gsap.to(".img-maruee-track.is-1", {
        xPercent: -50,
        repeat: -1,
        ease: "none",
        duration: 20
      });

    
      gsap.to(".img-maruee-track.is-2", {
        xPercent: 50,
        repeat: -1,
        ease: "none",
        duration: 20
      });

    }, bannerRef);

    return () => ctx.revert();
  }, []);


  const FAQref = useRef(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      gsap.from(".faq-heading h2", {
        y: 120,
        opacity: 0,
        stagger: 0.1,
        duration: 1,
        ease: "power3.out",
        scrollTrigger: { trigger: FAQref.current, start: "top 80%" }
      });
      
         gsap.from(".is-row-1", {
        xPercent: 4,
        scrollTrigger: {
          trigger: ".is-row-1",
          start: "top 85%",
          scrub: 1
        }
      });

         gsap.from(".is-row-4", {
        xPercent: 2,
        scrollTrigger: {
          trigger: ".is-row-4",
          start: "top 85%",
          scrub: 1
        }
      });

      gsap.from(".faq-item", {
        y: 60,
        opacity: 0,
        stagger: 0.08,
        duration: 0.6,
        scrollTrigger: { trigger: ".faq-list", start: "top 85%" }
      });

      gsap.to(".git-marquee", {
        xPercent: -50,
        repeat: -1,
        duration: 25,
        ease: "none"
      });
    }, FAQref);

    return () => ctx.revert();
  }, []);



  return (

    <div className="main-wrapper">
     <section ref={heroRef} className="section is-home-hero">
      {/* Desktop */}
      <div className="container-lg is-h-padded is-hero">

        <div className="h-row is-herow-1">
          <div className="h1-s-wrap is-h-wrap-1">
             <h1 className="h1-s">Future-ready FoodSafe</h1>
          </div>
        </div>

        <div className="h-row is-herow-2">
          <div className="h1-s-wrap is-h-wrap-2">
            <h1 className="h1-ss">Processing engineered to</h1>
          </div>
        </div>

        {/* <div className="h-row is-herow-3">
          <div className="flex-l-c is-hero">
            <div className="h1-s-wrap is-h-wrap-3">
              <h1 className="h1-ss">Processing</h1>
            </div>
            <div className="dash"></div>
          </div>

          <div className="h1-s-wrap is-h-wrap-4">
            <h1 className="h1-s">built to globaly</h1>
          </div>
        </div> */}

        {/* <div className="h-row is-herow-4">
          <div className="h1-s-wrap is-h-wrap-5">
            <h1 className="h1-s">  global standards</h1>
          </div>
        </div> */}

        <div className="h-row is-herow-4">
          <div className="h1-s-wrap is-h-wrap-6">
            <h1 className="h1-s">global standards</h1>
          </div>

          <div className="home-hero-img-wrapper">
            <div className="img-child">
              <div className="home-hero-video">
                <video autoPlay loop muted playsInline>
                  <source src={video} />
                </video>
              </div>
            </div>
          </div>
        </div>

      </div>

      {/* Mobile */}
      <div className="container-lg is-h-padded is-hero is-mobile">

        <div className="h-row is-herow-1">
          <div className="h1-s-wrap is-h-wrap-1">
            <h1 className="h1-s">Future-ready</h1>
          </div>
        </div>

        {/* <div className="h-row is-herow-2">
          <div className="h1-s-wrap is-h-wrap-2">
            <h1 className="h1-s"> -ready  </h1>
          </div>
        </div> */}
         <div className="h-row is-herow-3">
          <div className="h1-s-wrap is-h-wrap-3">
            <h1 className="h1-ss">FoodSafe </h1>
          </div>
        </div>
        <div className="h-row is-herow-4">
          <div className="h1-s-wrap is-h-wrap-4">
            <h1 className="h1-ss">Processing</h1>
          </div>
        </div>

        <div className="h-row is-herow-5">
          <div className="h1-s-wrap is-h-wrap-5">
            <h1 className="h1-ss">engineered to</h1>
          </div>
        </div>

        <div className="h-row is-herow-6">
          <div className="h1-s-wrap is-h-wrap-6">
            <h1 className="h1-ss"> global </h1>
          </div>
        </div>

        <div className="h-row is-herow-7">
          
          <div className="h1-s-wrap is-h-wrap-7">
            <h1 className="h1-s">standards.</h1>
          </div>
        </div>

        {/* <div className="h-row is-herow-6">
          <div className="h1-s-wrap is-h-wrap-7">
            <h1 className="h1-s">Safety</h1>
          </div>
        </div>

        <div className="h-row is-herow-7">
          <div className="h1-s-wrap is-h-wrap-8">
            <h1 className="h1-s">& reliability</h1>
          </div>
        </div> */}

        <div className="h-row is-herow-8">
          {/* <div className="h1-s-wrap is-h-wrap-6">
            <h1 className="h1-ss">Since 2017</h1>
          </div> */}

          <div className="home-hero-img-wrapper">
            <div className="img-child">
              <div className="home-hero-video">
                <video autoPlay loop muted playsInline>
                  <source src={video} />
                </video>
              </div>
            </div>
          </div>
        </div>

      </div>

      {/* Marquee */}
      <div className="hero-img-marquee">
        <div className="hero-img-track">

          {[1,2].map((row)=>(
            <div className="hero-img-marq" key={row}>
              {[1,2,3,4,5, 1,2,3,4,5].map((img,i)=>(
                <div className="hero-img-wrap" key={i}>
                  <div className="img-child">
                    <div className={`hero-slider-img is-${img}`}></div>
                  </div>
                </div>
              ))}
            </div>
          ))}

        </div>
      </div>

    </section>

    <section ref={aboutRef} className="section">
      <div className="container-lg is-h-padded">

        <div className="h-row is-row-1">
          <div className="h2-wrap"><h2 className="h2">Built</h2></div>
          <div className="h2-wrap row-2"><h2 className="h2-stroke">on hygienic engineering</h2></div>
        </div>

        <div className="h-row is-row-2">
          <div className="h2-wrap"><h2 className="h2">and</h2></div>
          <div className="h2-wrap row-2"><h2 className="h2-stroke"> foodsafe conveyance,</h2></div>
             
        </div>

        <div className="h-row is-row-3 is-sepcial">
          <div className="h2-wrap"><h2 className="h2">PthruP now delivers</h2></div>
          <div className="h2-wrap row-2 is-special">
            <h2 className="h2-stroke">end-to-end poultry</h2>
          </div>
        </div>

        <div className="h-row is-row-4 is-below-special">
          <div className="h2-wrap row-2"><h2 className="h2-stroke">and food</h2></div>
          <div className="h2-wrap"><h2 className="h2">processing solutions</h2></div>
        </div>

        <div className="h-underline"></div>

      </div>
    </section>

       <section ref={sectionRef} className="section is-openning">
      <div className="sticky-img-wrapper">

        <div className="flex-hide is-gap-1">

          {/* LEFT COLUMN */}
          <div className="column is-left">
            <div className="img-wrapper">
              <div className="img-child">
                <div className="ind-img is-1"></div>
                <div className="ind-img is-2"></div>
                <div className="overlay"></div>
              </div>
            </div>

       <div className="col-content">
    <div className="d-50">
        <p className="ind-swap-text is-1">
           Our consulting services help poultry processors open the door to higher efficiency, better hygiene, and scalable growth — through expert process analysis, layout optimization, and practical engineering guidance.

        </p>
        <p className="ind-swap-text is-2">
           Our consulting services help poultry processors open the door to higher efficiency, better hygiene, and scalable growth — through expert process analysis, layout optimization, and practical engineering guidance.
        </p>
    </div>
    <div className="flex-v-l">
        <div className="ab-no-wrap">
            <div className="serv-no is-3"
                >
                01</div>
            <div className="serv-no is-1"
                >
                01</div>
        </div>
        <div className="h2-frame ind-swap-text is-1">
            <div className="h2-wrap row-1 "
                >
                <h2 className="h2 txt-white">Consulting</h2>
            </div>
            <div className="h2-wrap "
                >
                <h2 className="h2 txt-white">Services</h2>
            </div>
        </div>
        <div className="h2-frame ind-swap-text is-2">
            <div className="h2-wrap"
                >
                <h2 className="h2 txt-white">Consulting</h2>
            </div>
            <div className="h2-wrap"
                >
                <h2 className="h2 txt-white">Services</h2>
            </div>
        </div>
    </div>
</div>
          </div>

          {/* RIGHT COLUMN */}
          <div className="column is-right">
            <div className="img-wrapper">
              <div className="img-child">
                <div className="ind-img is-3"></div>
                <div className="ind-img is-4"></div>
                <div className="overlay"></div>
              </div>
            </div>

           <div className="col-content">
                <div className="d-50">
                    <p className="ind-swap-text is-1">Our engineered solutions combine hygienic design, proven equipment, and integrated execution to deliver reliable, high-performance poultry processing systems.</p>
                    <p className="ind-swap-text is-2">Our engineered solutions combine hygienic design, proven equipment, and integrated execution to deliver reliable, high-performance poultry processing systems.</p>
                </div>
                <div className="flex-v-l">
                    <div className="ab-no-wrap">
                        <div className="serv-no is-2">
                            02</div>
                        <div className="serv-no is-4">
                            02<br/></div>
                    </div>
                    <div className="w-layout-hflex h2-frame ind-swap-text is-1">
                        <div className="h2-wrap">
                            <h2 className="h2 txt-white">Engineered</h2>
                        </div>
                        <div className="h2-wrap">
                            <h2 className="h2 txt-white">Solutions</h2>
                        </div>
                    </div>
                    <div className="h2-frame ind-swap-text is-2">
                        <div className="h2-wrap">
                            <h2 className="h2 txt-white">Engineered</h2>
                        </div>
                        <div className="h2-wrap">
                            <h2 className="h2 txt-white">Solutions</h2>
                        </div>
                    </div>
                </div>
            </div>
          </div>

          {/* CENTER EMERGE BLOCK */}
          <div className="surprise-column">
            <div className="emerge-frame">
              <div className="container-lg flex-cc-v is-heading">
            <div className="emerge-img-wrap is-ei-1"><div className="img-child"><div className="eme-img-1"/></div></div>
            <div className="emerge-img-wrap is-ei-2"><div className="img-child"><div className="eme-img-2"/></div></div>

          {/* <div className="h2-wrap no-margin"><h2 className="h2-special">Get industry leading solutions </h2></div>
            <div className="h2-wrap no-margin"><h2 className="h2-special">when you associate with PthruP.</h2></div> */}
            <div className="h2-wrap no-margin"><h2 className="h2-stroke is-black">PthruP built around one promise</h2></div>
            <div className="h2-wrap no-margin"><h2 className="h2-special">Profit Through Process</h2></div>

              <a href="/about" className="btn w-inline-block">
                   <div className="btn-text-wrap">
                      <div className="btn-text-white">More About us</div>
                   </div>
                   
               </a>
              </div>
              <div className="container-lg flex-cc-v is-heading is-mobile is-inner">
                 <div className="emerge-img-wrap is-ei-1"><div className="img-child"><div className="eme-img-1"/></div></div>
            <div className="emerge-img-wrap is-ei-2"><div className="img-child"><div className="eme-img-2"/></div></div>

          <div className="h2-wrap no-margin"><h2 className="h2-special">PthruP built</h2></div>
            <div className="h2-wrap no-margin"><h2 className="h2-special">around one promise</h2></div>
            <div className="h2-wrap no-margin"><h2 className="h2-stroke is-black">Profit Through</h2></div>
            <div className="h2-wrap no-margin"><h2 className="h2-special">Process</h2></div>

              <a href="/about" className="btn w-inline-block">
                   <div className="btn-text-wrap">
                      <div className="btn-text-white">More About us</div>
                   </div>
                   
               </a>
              </div>
            </div>

          </div>

        </div>
      </div>
    </section>
    <section className="section" ref={specialiseRef}>
      <div className="container-lg is-heading">
		
      <div className="h-row is-row-1">
        <div className="h2-wrap"><h2 className="h2">We </h2></div>
        <div className="h2-wrap row-2"><h2 className="h2-stroke">specialise</h2></div>
        <div className="h2-wrap"><h2 className="h2"> in FoodSafe </h2></div>
        <div className="h2-wrap row-2"><h2 className="h2-stroke">engineering, </h2></div>
      </div>

      <div className="h-row is-row-2">
        <div className="h2-wrap row-2"><h2 className="h2-stroke">hygienic design </h2></div>
        <div className="h2-wrap"><h2 className="h2">and automation </h2></div>
      </div>

      <div className="h-row is-row-3 is-special">
        <div className="h2-wrap"><h2 className="h2">to reduce</h2></div>
        <div className="h2-wrap row-2 is-special">
          <h2 className="h2-stroke">contamination risks while </h2>
        </div>
      </div>

      <div className="h-row is-row-4 is-below-special">
        <div className="h2-wrap"><h2 className="h2">improving</h2></div>
        <div className="h2-wrap row-2"><h2 className="h2-stroke">yield, efficiency</h2></div>
        <div className="h2-wrap"><h2 className="h2">and line uptime</h2></div>
      </div>

    </div>
    <div className="container-lg is-h-padded is-mobile">
       <div className="h-row is-row-1">
        <div className="h2-wrap"><h2 className="h2">We </h2></div>
        <div className="h2-wrap row-2"><h2 className="h2-stroke">specialise</h2></div>
        <div className="h2-wrap"><h2 className="h2"> in FoodSafe </h2></div>
        <div className="h2-wrap row-2"><h2 className="h2-stroke">engineering </h2></div>
      </div>

      <div className="h-row is-row-2">
        <div className="h2-wrap row-2"><h2 className="h2-stroke">hygienic design </h2></div>
        <div className="h2-wrap"><h2 className="h2">and automation </h2></div>
      </div>

      <div className="h-row is-row-3 is-special">
        <div className="h2-wrap"><h2 className="h2">to reduce</h2></div>
         <div className="h2-wrap"><h2 className="h2">contamination</h2></div>
        <div className="h2-wrap row-2 is-special">
          <h2 className="h2-stroke"> risks while </h2>
        </div>
      </div>

      <div className="h-row is-row-4 is-below-special">
        <div className="h2-wrap"><h2 className="h2">improving</h2></div>
        <div className="h2-wrap row-2"><h2 className="h2-stroke">yield, efficiency</h2></div>
        <div className="h2-wrap"><h2 className="h2">and line uptime</h2></div>
      </div>
    </div>
      <div className="container-lg is-c-space">
            <div className="para-wrapper">
              <div className="d-30 is-mobile">
                <p className="text text-reveal">
                PthruP is a hygienic engineering and foodsafe conveyance specialist that now delivers end-to-end poultry and food processing systems
                </p>
              </div>
            </div>
          </div>


          <div className="h-scroll card-hover-mouseover">
    <div className="card-row">
        <div className="h-scroll-card">
            {/* <div className="sm-anim-wrapper">
                <div className="icon-wrapper is-home" >
                    <div className="wcu-lottie">
                        <img className="img-responsive" src={icon01} alt="End-to-end FoodSafe Portfolio"/>
                     </div>
                </div>
                <div className="whipe-black is-c-1"></div>
                <div className="cracks-marquee">
                    <div className="cracks-marquee-move"
                        >
                        <div className="cracks-img"></div>
                        <div className="cracks-img"></div>
                    </div>
                </div>
            </div> */}
            <div className="h-scroll-content">
                <h3 className="h3">End-to-end FoodSafe<br/>Portfolio</h3>
                <div className="flex-r-s hover-r-q">
                    <div className="d-100">
                        <p  className="text txt-white">
                          From factory process layout and hygienic structures to sanitation equipment, audits and digital food safety systems, PthruP covers every step of your processing line.
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div className="h-scroll-card">
            {/* <div className="sm-anim-wrapper">
                <div className="whipe-black is-c-2"></div>
                <div className="icon-wrapper is-home" >
                    <div className="wcu-lottie">
                           <img className="img-responsive" src={icon02} alt="Hygienic design"/>
                        </div>
                </div>
                <div className="cracks-marquee">
                    <div  className="cracks-marquee-move"
                        >
                        <div className="cracks-img"></div>
                        <div className="cracks-img"></div>
                    </div>
                </div>
            </div> */}
            <div className="h-scroll-content">
                <h3 className="h3">Hygienic design<br/>at the core</h3>
                <div className="flex-r-s hover-r-q">
                    <div className="d-100">
                        <p  className="text txt-white">Conveyors and equipment are built with hygienic materials, minimal fasteners, tool-less disassembly and no “sandwich joints”, making cleaning faster and reducing harborage points.</p>
                    </div>
                </div>
            </div>
        </div>
        <div className="h-scroll-card">
            {/* <div className="sm-anim-wrapper">
                <div className="whipe-black is-c-3"></div>
                <div className="icon-wrapper is-home" >
                    <div className="wcu-lottie">
                     <img className="img-responsive" src={icon03} alt="Hygienic design"/>       
                    </div>
                </div>
                <div className="cracks-marquee">
                    <div className="cracks-marquee-move"
                        >
                        <div className="cracks-img"></div>
                        <div className="cracks-img"></div>
                    </div>
                </div>
            </div> */}
            <div className="h-scroll-content">
                <h3 className="h3">Proven poultry<br/>processing expertise</h3>
                <div className="flex-r-s hover-r-q">
                    <div className="d-100">
                        <p  className="text txt-white">
                          PthruP has executed one of India’s largest food processing conveyor projects, delivering over 30 ThermoDrive conveyors and 520 meters of hygienic belting for high-throughput poultry lines.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div className="card-row is-top">
        <div className="h-scroll-card">
            {/* <div className="sm-anim-wrapper">
                <div className="whipe-black is-c-1"></div>
                <div className="icon-wrapper is-home" >
                    <div className="wcu-lottie">
                      <img className="img-responsive" src={icon04} alt="Hygienic design"/>       
                    </div>
                </div>
                <div className="cracks-marquee">
                    <div data-w-id="32fe7565-daf0-f289-624b-4cfa515e2531" className="cracks-marquee-move"
                        >
                        <div className="cracks-img"></div>
                        <div className="cracks-img"></div>
                    </div>
                </div>
            </div> */}
            <div className="h-scroll-content">
                <h3 className="h3">Global technology,<br/>local integration</h3>
                <div className="flex-r-s hover-r-q">
                    <div className="d-100">
                        <p  className="text txt-white">Backed by global technology leaders from France, Belgium, Brazil, Thailand, PthruP uses its manufacturing base in India for fast, reliable execution.​​</p>
                    </div>
                </div>
            </div>
        </div>
        <div className="h-scroll-card">
            {/* <div className="sm-anim-wrapper">
                <div className="whipe-black is-c-2"></div>
                <div className="icon-wrapper is-home" >
                    <div className="wcu-lottie">
                        <img className="img-responsive" src={icon05} alt="Hygienic design"/>
                    </div>
                </div>
                <div className="cracks-marquee">
                    <div data-w-id="dd84822f-13f5-c642-5cee-fa9da5863503" className="cracks-marquee-move"
                        >
                        <div className="cracks-img"></div>
                        <div className="cracks-img"></div>
                    </div>
                </div>
            </div> */}
            <div className="h-scroll-content">
                <h3 className="h3">Continuous<br/>improvement focus</h3>
                <div className="flex-r-s hover-r-q">
                    <div className="d-100">
                        <p  className="text txt-white">
                          Services extend beyond installation, with sanitation training, food safety audits, CFS certification support, traceability solutions and digital food safety management tools.​​
                        </p>
                    </div>
                </div>
            </div>
        </div>

            <div className="h-scroll-card">
            {/* <div className="sm-anim-wrapper">
                <div className="whipe-black is-c-2"></div>
                <div className="icon-wrapper is-home" >
                    <div className="wcu-lottie">
                        <img className="img-responsive" src={icon05} alt="Hygienic design"/>
                    </div>
                </div>
                <div className="cracks-marquee">
                    <div data-w-id="dd84822f-13f5-c642-5cee-fa9da5863503" className="cracks-marquee-move"
                        >
                        <div className="cracks-img"></div>
                        <div className="cracks-img"></div>
                    </div>
                </div>
            </div> */}
            <div className="h-scroll-content">
                <h3 className="h3">Trust and <br/>brand protection</h3>
                <div className="flex-r-s hover-r-q">
                    <div className="d-100">
                        <p  className="text txt-white">
                          Our solutions at Pthrup are designed to help food manufacturers improve hygiene, efficiency, and profitability thus protecting your brand from any food safety risks.
                        </p>
                    </div>
                </div>
            </div>
        </div>

        {/* <div className="h-scroll-card is-cta">
            <div className="h-scroll-content is-cta">
                <h3 className="h3 txt-white">Trust and <br/>brand protection</h3>
                <div className="flex-l-s">
                    <div className="d-70">
                        <p className="text txt-white" >
                    Our solutions at Pthrup are designed to help food manufacturers improve hygiene, efficiency, and profitability thus protecting your brand from any food safety risks. </p>
                    </div>
                </div>
            </div>
            <div className="card-btm-action-wrapper">
                <div className="action"><a href="/services"
                        className="btn w-inline-block">
                        <div className="btn-text-wrap">
                            <div 
                                className="btn-text-white">Learn More</div>
                            <div
                                className="btn-text-black-ab">Learn More</div>
                        </div>
                        <div 
                            className="whipe-white"></div>
                    </a></div>
            </div>
            <div className="home-about-img-wrapper">
                <div className="img-child">
                    <div className="home-about-img"></div>
                </div>
            </div>
        </div> */}
    </div>
    {/* <div className="h-scroll-card is-cta is-mobile">
        <div className="h-scroll-content is-cta">
            <div className="flex-l-s">
                <div className="d-70">
                    <p className="text txt-white" >Our Services extend beyond installation, with sanitation training, food safety audits, CFS certification support, traceability solutions and digital food safety management tools.​​
</p>
                </div>
            </div>
        </div>
        <div className="card-btm-action-wrapper">
            <div className="action no-margin"><a  href="/services"
                    className="btn w-inline-block">
                    <div className="btn-text-wrap">
                        <div 
                            className="btn-text-white">Learn More</div>
                        <div
                            className="btn-text-black-ab">Learn More</div>
                    </div>
                    <div 
                        className="whipe-white"></div>
                </a></div>
        </div>
        <div className="home-about-img-wrapper">
            <div className="img-child">
                <div className="home-about-img"></div>
            </div>
        </div>
    </div> */}
</div>
    </section>
   
   
     <section ref={industriesRef} className="section">
      <div className="container-lg is-h-padded">
        <div className="h-row is-row-1">
          <div className="h2-wrap"><h2 className="h2-stroke">we work with</h2></div>
          <div className="h2-wrap row-2"><h2 className="h2"> food businesses</h2></div>
               <div className="h2-wrap"><h2 className="h2-stroke"> where hygiene,</h2></div>
        </div>

        <div className="h-row is-row-2">
          {/* <div className="h2-wrap"><h2 className="h2-stroke">hygiene, </h2></div> */}
          <div className="h2-wrap row-2"><h2 className="h2"> compliance, </h2></div>
          <div className="h2-wrap"><h2 className="h2">and uptime</h2></div>
              <div className="h2-wrap"><h2 className="h2-stroke">are non-negotiable.</h2></div>

        </div>
         {/* <div className="h-row is-row-2">
          <div className="h2-wrap"><h2 className="h2-stroke">are non-negotiable.</h2></div>
        </div> */}
      </div>

          <div className="container-lg is-h-padded is-mobile">
        <div className="h-row is-row-1">
          <div className="h2-wrap"><h2 className="h2-stroke">we work with</h2></div>
          <div className="h2-wrap row-2"><h2 className="h2"> food businesses</h2></div>
               <div className="h2-wrap"><h2 className="h2-stroke"> where</h2></div>
        </div>

        <div className="h-row is-row-2">
          <div className="h2-wrap"><h2 className="h2-stroke">hygiene, </h2></div>
          <div className="h2-wrap row-2"><h2 className="h2"> compliance, </h2></div>
          <div className="h2-wrap"><h2 className="h2">and uptime </h2></div>
        </div>
         <div className="h-row is-row-2">
          <div className="h2-wrap"><h2 className="h2-stroke">are non-negotiable.</h2></div>
        </div>
      </div>
        <div className="container-lg is-c-space">
            <div className="para-wrapper">
              <div className="d-30 is-mobile">
                <p className="text text-reveal">
               PthruP partners with processors who demand reliable, FoodSafe operations and delivers <b>tailored engineering solutions</b> designed to meet high-volume production, regulatory requirements, and long-term operational performance across multiple food segments.
                </p>
              </div>
            </div>
          </div>

    </section>

    <ServicesCards/>


    
    
<section ref={leadingRef} className="section top-btm-padded bg-black leading-provider">
      <div className="logo-block">
        <div className="container-lg is-heading logo-heading">
          <div className="h-row is-row-1">
            <h2 className="h2 txt-white">How PthruP takes ​</h2>
            <h2 className="h2-stroke is-black">you from risk ​</h2>
            <h2 className="h2 txt-white">to FoodSafe-ready.</h2>
          </div>

          {/* <div className="h-row is-row-2">
            <h2 className="h2 txt-white">FoodSafe-ready.</h2>
          </div> */}

           {/* <div className="h-row is-row-3">
            <h2 className="h2 txt-white">across India </h2>
          
            <h2 className="h2 txt-white">And</h2>
            <h2 className="h2-stroke is-black">and beyond</h2>
          </div> */}
        </div>
 <div className="container-lg is-h-padded is-mobile logo-heading">
          <div className="h-row is-row-1">
            <h2 className="h2 txt-white">How PthruP  </h2>
            <h2 className="h2-stroke is-black">takes you</h2>
           <h2 className="h2-stroke is-black">from risk</h2>
          </div>

          <div className="h-row is-row-2">
            <h2 className="h2 txt-white">to </h2>
            <h2 className="h2 txt-white">FoodSafe-ready.</h2>
            
          </div>

          <div className="h-row is-row-1">
            <h2 className="h2-stroke txt-white is-black"> across India </h2>
            <h2 className="h2 txt-white">And</h2>
            <h2 className="h2-stroke is-black">and beyond</h2>
          </div>
        </div>
        
 <div className="container-lg is-c-space"></div>
        

          <div className="h-scroll">
               {/* <div className="h-scroll-card is-cta is-mobile">
        <div className="h-scroll-content is-cta">
            <div className="flex-l-s">
                <div className="d-70">
                    <p className="text txt-white" >hygienic conveyor systems, poultry processing solutions and FoodSafe engineering services</p>
                </div>
            </div>
        </div>
       
        <div className="home-about-img-wrapper">
            <div className="img-child">
                <div className="home-about-img"></div>
            </div>
        </div>
    </div> */}
    <div className="card-row process-row">
        <div className="h-scroll-card">
       
            <div className="h-scroll-content">
               <h3 className="h3 cr-text">Process Overview</h3>
                <div className="flex-r-s z-index-1">
                    <div className="d-70">
                     <h3 className="h3-trap text txt-white">
                          Learn more about how PthruP can protect your brand</h3>
                    </div>
                </div>
            </div>
            {/* <div className="card-btm-action-wrapper">
                <div className="action"><a href="/services"
                        className="btn w-inline-block">
                        <div className="btn-text-wrap">
                            <div 
                                className="btn-text-white">Learn More</div>
                            <div
                                className="btn-text-black-ab">Learn More</div>
                        </div>
                        <div 
                            className="whipe-white"></div>
                    </a></div>
            </div> */}
            <div className="home-about-img-wrapper">
                <div className="img-child">
                    <div className="home-about-img"></div>
                </div>
            </div>
        </div>
        <div className="h-scroll-card">
             <div className="bg-logo-img is-1"></div>
            {/* <div className="sm-anim-wrapper">
                <div className="icon-wrapper is-home" >
                    <div className="wcu-lottie">
                        <img className="img-responsive" src={icon01} alt="End-to-end FoodSafe Portfolio"/>
                     </div>
                </div>
                <div className="whipe-black is-c-1"></div>
                <div className="cracks-marquee">
                    <div className="cracks-marquee-move"
                        >
                        <div className="cracks-img"></div>
                        <div className="cracks-img"></div>
                    </div>
                </div>
            </div> */}
            <div className="h-scroll-content">
                <h3 className="h3 cr-text">Discover & assess</h3>
                <div className="flex-r-s">
                    <div className="d-70">
                        <h3 className="h3-trap text txt-white">
                          Site visit, process study and FoodSafe risk assessment to understand current layouts, equipment and sanitation practices.
                        </h3>
                    </div>
                </div>
            </div>
        </div>
        <div className="h-scroll-card">
            <div className="bg-logo-img is-2"></div>
            {/* <div className="sm-anim-wrapper">
                <div className="whipe-black is-c-2"></div>
                <div className="icon-wrapper is-home" >
                    <div className="wcu-lottie">
                           <img className="img-responsive" src={icon02} alt="Hygienic design"/>
                        </div>
                </div>
                <div className="cracks-marquee">
                    <div  className="cracks-marquee-move"
                        >
                        <div className="cracks-img"></div>
                        <div className="cracks-img"></div>
                    </div>
                </div>
            </div> */}
            <div className="h-scroll-content">
                <h3 className="h3 cr-text">Design & simulate</h3>
                <div className="flex-r-s">
                    <div className="d-70">
                        <h3 className="h3-trap text txt-white">
                          Hygienic factory layouts, line concepts and equipment selections are engineered to meet capacity, compliance and cleaning requirements.​​
                        </h3>
                    </div>
                </div>
            </div>
        </div>
      
    </div>
    <div className="card-row process-row is-top">
        <div className="h-scroll-card">
            <div className="bg-logo-img is-3"></div>
            {/* <div className="sm-anim-wrapper">
                <div className="whipe-black is-c-3"></div>
                <div className="icon-wrapper is-home" >
                    <div className="wcu-lottie">
                     <img className="img-responsive" src={icon03} alt="Hygienic design"/>       
                    </div>
                </div>
                <div className="cracks-marquee">
                    <div className="cracks-marquee-move"
                        >
                        <div className="cracks-img"></div>
                        <div className="cracks-img"></div>
                    </div>
                </div>
            </div> */}
            <div className="h-scroll-content">
                <h3 className="h3 cr-text">Build & integrate</h3>
                <div className="flex-r-s">
                    <div className="d-70">
                        <h3 className="h3-trap text txt-white">
                         Conveyors, structures and process equipment are manufactured in PthruP’s facility and integrated on-site with minimal disruption.
                        </h3>
                    </div>
                </div>
            </div>
        </div>
        <div className="h-scroll-card">
            <div className="bg-logo-img is-4"></div>
            {/* <div className="sm-anim-wrapper">
                <div className="whipe-black is-c-1"></div>
                <div className="icon-wrapper is-home" >
                    <div className="wcu-lottie">
                      <img className="img-responsive" src={icon04} alt="Hygienic design"/>       
                    </div>
                </div>
                <div className="cracks-marquee">
                    <div data-w-id="32fe7565-daf0-f289-624b-4cfa515e2531" className="cracks-marquee-move"
                        >
                        <div className="cracks-img"></div>
                        <div className="cracks-img"></div>
                    </div>
                </div>
            </div> */}
            <div className="h-scroll-content">
                <h3 className="h3 cr-text">Sanitize & validate</h3>
                <div className="flex-r-s">
                    <div className="d-70">
                        <h3 className="h3-trap text txt-white">
                          Sanitation programs, tools and training are deployed to validate cleaning effectiveness and reduce contamination risks.​​
                        </h3>
                    </div>
                </div>
            </div>
        </div>
        <div className="h-scroll-card">
            <div className="bg-logo-img is-5"></div>
            {/* <div className="sm-anim-wrapper">
                <div className="whipe-black is-c-2"></div>
                <div className="icon-wrapper is-home" >
                    <div className="wcu-lottie">
                        <img className="img-responsive" src={icon05} alt="Hygienic design"/>
                    </div>
                </div>
                <div className="cracks-marquee">
                    <div data-w-id="dd84822f-13f5-c642-5cee-fa9da5863503" className="cracks-marquee-move"
                        >
                        <div className="cracks-img"></div>
                        <div className="cracks-img"></div>
                    </div>
                </div>
            </div> */}
            <div className="h-scroll-content">
                <h3 className="h3 cr-text">Digitize & improve</h3>
                <div className="flex-r-s">
                    <div className="d-70">
                        <h3 className="h3-trap text txt-white">
                        Traceability and digital food safety management solutions enable ongoing monitoring, audits and continuous improvement.​​

                        </h3>
                    </div>
                </div>
            </div>
        </div>
      
    </div>
 
</div>
      </div>

     
    </section>


        <section ref={serviceRef} className="section top-btm-padded ">

             <div className="container-lg is-h-padded">

                 <div className="trust-flex-auto">
                  <img className="responsive" src={trust00} alt="trust"/>
                          <div className="trust-h2">
                             
                            <div className="h-row is-row-1">
                                      <div className="h2-wrap"><h2 className="h2-stroke">Trusted </h2></div>
                                      <div className="h2-wrap row-2"><h2 className="h2">FoodSafe partner with global </h2></div>
                                    </div>

                                    <div className="h-row is-row-2">
                                      <div className="h2-wrap"><h2 className="h2-stroke">technology  </h2></div>
                                      <div className="h2-wrap row-2"><h2 className="h2">and  certified manufacturing</h2></div>
                                    </div>
                                     {/* <div className="h-row is-row-3">
                                      <div className="h2-wrap"><h2 className="h2">certified manufacturing</h2></div>
                                    </div> */}
                          </div>
                 </div>
      

      </div>


      <div className="container-lg is-h-padded is-mobile">
           <div className="trust-flex-auto">
             <img className="responsive" src={trust00} alt="trust"/>
                 <div className="trust-h2">
                  <div className="h-row is-row-1">
          <div className="h2-wrap"><h2 className="h2-stroke">Trusted </h2></div>
          <div className="h2-wrap row-2"><h2 className="h2">FoodSafe  </h2></div>
        </div>

        <div className="h-row is-row-2">
          <div className="h2-wrap"><h2 className="h2-stroke">partner with  </h2></div>
          <div className="h2-wrap row-2"><h2 className="h2">global technology  </h2></div>
          <div className="h2-wrap"><h2 className="h2">and certified</h2></div>
        </div>
           <div className="h-row is-row-1">
        <div className="h2-wrap"><h2 className="h2">manufacturing</h2></div>
       
      </div>
                 </div>
           </div>
         </div>
        <div className="container-lg is-c-space">
            <div className="para-wrapper li-wrapper trusted-container">
              <div className="trust-col-03">
                    <div className="trust-col-12">
                          <div className="h-row is-row-1">
                             <h3 class="h3 line-height-wrap"><b class="h2-stroke line-normal">01. </b>Specializing in high-precision engineering and assembly.</h3>
                          </div>

                          <div className="trust-container-image">
                               <img className="responsive" src={trust01} alt="trust"/>
                          </div>

                          <div className="h--row is-row-2 d-100">
                             <h3 class="h3 text-center is-center">Manufacturing campus in</h3>
                          </div>

                           <div className="trust-container-image">
                               <img className="responsive" src={trust02} alt="trust"/>
                          </div>

                    </div>
              </div>
              <div className="trust-col-03 middle-trust">
                    <div className="trust-col-12">
                          <div className="h-row is-row-1">
                             <h3 class="h3 line-height-wrap"><b class="h2-stroke line-normal">02. </b>Trained on the 10 principles of Hygienic Design by CFS, USA</h3>
                          </div>

                           <div className="trust-container-image">
                               <img className="responsive" src={trust03} alt="trust"/>
                          </div>
                          
                  
                             <h4 class="line-height-wrap text is-center">Certified sanitary engineering standards.</h4>
                        
                    </div>
              </div>
              <div className="trust-col-03">
                    <div className="trust-col-12">
                         <div className="trust-container">
                            <div className="h-row is-row-1">
                              <h3 class="h3 line-height-wrap"><b class="h2-stroke line-normal">03. </b>Strategic partnerships with advanced processing equipment providers</h3>
                            </div>
                         </div>

                          <div className="trust-container-image-flex">
                              <div className="trust-ct"><img className="responsive" src={trust04} alt="trust"/><h4>France</h4></div>
                              <div className="trust-ct"><img className="responsive" src={trust05} alt="trust"/><h4>Brazil</h4></div>
                              <div className="trust-ct"><img className="responsive" src={trust06} alt="trust"/><h4>Thailand</h4></div>
                              <div className="trust-ct"><img className="responsive" src={trust07} alt="trust"/><h4>Belgium</h4></div>
                          </div>

                          <div className="h-row is-row-1 text-center flex-dashed">
                              <div className="dashed"></div>
                              <h3 class="h3 line-height-wrap"><img className="responsive" src={trust10} alt="trust"/>&nbsp;Partnerships</h3>
                            </div>

                          <div className="h-row is-row-1">
                              <h3 class="h3 line-height-wrap"><b class="h2-stroke line-normal">04. </b>Proven execution for leading poultry processors in India, including large-scale, high-throughput conveyor projects</h3>
                            </div>

                           <div className="trust-container">
                            

                             <div className="trust-flex">
                                   <div className="trust-container-image">
                                <img className="responsive" src={trust08} alt="trust"/>
                                <h4 class="line-height-wrap text is-center">Hygienic Desigin Conveyor </h4>
                             </div>
                             

                             <div className="trust-container-image-grid">
                                <img className="responsive" src={trust09} alt="trust"/>
                               <h4 class="line-height-wrap text">Track record of reliability with industry giants.</h4>
                             </div>
                             </div>
                         </div>
                    </div>
              </div>
            </div>
          </div>

    </section>
    <section ref={logoRef} className="section top-btm-padded bg-black logo-waver">
           <div className="logo-block">
        <div className="container-lg is-heading logo-heading">
          <div className="h-row">
            <h2 className="h2 txt-white">And, we are proud to be</h2>
          </div>
          <div className="h-row">
            <h2 className="h2-stroke is-black">trusted by industry leaders</h2>
          </div>
        </div>

        <div className="container-lg is-h-padded is-mobile logo-heading">
          <div className="h-row">
            <h2 className="h2 txt-white">And, we are </h2>
            <h2 className="h2 txt-white">proud to be</h2>
          </div>
          <div className="h-row">
            <h2 className="h2-stroke is-black">trusted by</h2>
              <h2 className="h2 txt-white">industry leaders</h2>
          </div>
        </div>

        <div >
    <div className="quick-stack-wrapper is-1">
 <div className="img-marquee-wrapper is-home">
     <div className="maruee-track">
       <div className="img-marquee-col" ref={trackRef}>
      {Clients.map((client, i) => (
        <>
         <div className="marq-item-logo" key={i}>
          <img
            className="responsive"
            src={client.src}
            alt={client.name}
          />  
         </div>
       
           
       
        </>
        
      ))}
    </div>
    </div>
  </div>
    </div>
 
        
  </div>
 
    

    
      </div>
    </section>

    

   

    
    <section  ref={FAQref} className="section less-top-pad">
      <div className="container-lg is-heading faq-heading">
        <div className="h-row is-row-1">
          <div className="h2-wrap is-special">
              <h2 className="h2-stroke">Frequently Asked</h2>
          </div>

        </div>
    <div className="h-row is-row-4 is-below-special">
        <div className="h2-wrap is-special">
             <h2 className="h2">Questions from PthruP</h2>
        </div>
        </div>
      </div>

          <div className="container-lg is-h-padded is-mobile faq-heading">
        <div className="h-row is-row-1">
          <div className="h2-wrap is-special">
              <h2 className="h2-stroke">Frequently Asked</h2>
          </div>

        </div>
    <div className="h-row is-row-4 is-below-special">
        <div className="h2-wrap is-special">
             <h2 className="h2">Questions from PthruP</h2>
        </div>
        </div>
      </div>
      <div className="container-lg is-pad is-faq-wrapper">
        <div className="faq-split">
          {FAQS.map((item, i) => (
            <FAQItem key={i} {...item} />
          ))}
        </div>
      </div>
    
 
    </section>

<section ref={bannerRef} className="section is-no-pad">
      <div className="banner-img is-home">
        <div className="img-child">
          <div className="banner-img-frame">
            <div className="bn-img is-home is-1" />
            <div className="bn-img is-home is-2" />
          </div>
        </div>

        <div className="img-marquee-wrapper is-home">

          <div className="img-maruee-track is-1">
            <StatsRow />
          </div>

          <div className="other-wayblock">
            <div className="img-maruee-track is-2">
      
              <StatsRow />
            </div>
          </div>
         
        </div>
           <div class="card-btm-action-wrapper wrapper-about">
              <div class="action-center">
                    <a href="/contact" class="btn w-inline-block">
                    <div class="btn-text-wrap">
                      <div class="btn-text-white">Book a Site Visit</div>
                      <div class="btn-text-black-ab">Book a Site Visit</div>
                    </div>
                      <div class="whipe-white"></div>
                    </a>
                  </div>
             </div>
      </div>
    </section>
           <GetInTouch />

    </div>


  );
};



// function LogoStatsRow() {
//   return (
   
//   );
// }

// function LogoStat({ label }) {
//   return (
//     <div className="img-marq-flex">
//       <div className="marq-no-flex">
//         <div className="img-marq-txt is-fill is-home">
//           {label}
//         </div>
//       </div>
//     </div>
//   );
// }


function StatsRow() {
  return (
    <div className="img-marquee-col">

      <Stat label="Food safety engineering" />
      <div className="marq-line" />

      <Stat label="Hygienic Conveyor systems" />
      <div className="marq-line" />

      <Stat label="Poultry processing solutions" />
      <div className="marq-line" />

      <Stat label="foodsafe plant design" />
      <div className="marq-line" />

      <Stat label="Turnkey food processing lines" />
      <div className="marq-line" />
    </div>
  );
}

function Stat({ label }) {
  return (
    <div className="img-marq-flex">
      {/* <div className="marq-no-flex">
      </div> */}
      <div className="img-marq-txt is-fill is-home">{label}</div>
    </div>
  );
}





function FAQItem({ q, a }) {
  const [open, setOpen] = useState(false);
  const answerRef = useRef(null);

  const toggle = () => {
    setOpen(!open);
    gsap.to(answerRef.current, {
      height: open ? 0 : "auto",
      opacity: open ? 0 : 1,
      duration: 0.4,
      ease: "power2.out"
    });
  };

  return (

            <div className="faq-list-wrapper w-dyn-list">
 <div role="list" className="faq-list w-dyn-items">
                <div role="listitem" className="faq-item w-dyn-item">
                    <div className={`faq ${open ? "open" : ""}`} onClick={toggle}>
                        <div className="faq-q-frame-hide">
                            <div className="faq-ques-frame">
                                <div className="ques-txt-wrapper" >
                                    <div className="ques-txt is-not-ab"> {q}</div>
                                    <div className="ques-txt is-ab">{q}</div>
                                </div>
                                <div  className="faq-cross-wrapper">
                                    <div className="cross-wrap">
                                        <div className="f-line-v"></div>
                                        <div className="f-line-h"></div>
                                    </div>
                                    <div className="faq-cross-whipe"></div>
                                </div>
                                <div  className="whipe-black is-w-right"></div>
                            </div>
                        </div>
                        <div ref={answerRef} className="answer-wrapper" style={{ height: 0, opacity: 0, overflow: "hidden" }}>
                            <div className="answer-frame">
                                <div className="text w-richtext">
                                    <p>{a}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            </div>
           
    // <div className="faq-item">
    //   <button className="faq-question" onClick={toggle}>
    //     {q}
    //     <span className={`faq-plus ${open ? "open" : ""}`}>+</span>
    //   </button>
    //   <div ref={answerRef} className="faq-answer" style={{ height: 0, opacity: 0, overflow: "hidden" }}>
    //     <p>{a}</p>
    //   </div>
    // </div>
  );
}

// function GetInTouch() {
//   return (
//   <section className="get-in-touch">
//     <div className="git-marquee">
//         <div className="git-marq-col">
//             <div className="cross-wrap is-git">
//                 <div className="git-line-v"></div>
//                 <div className="git-line-h"></div>
//             </div>
//             <div className="git-text-wrap">
//                 <div className="git-text-stroke">Want Our Services?</div>
//             </div>
//             <div className="cross-wrap is-git">
//                 <div className="git-line-v"></div>
//                 <div className="git-line-h"></div>
//             </div>
//             <div className="git-text-wrap">
//                 <div className="git-text-stroke">Want Our Services?</div>
//             </div>
//         </div>
//         <div className="git-marq-col">
//             <div className="cross-wrap is-git">
//                 <div className="git-line-v"></div>
//                 <div className="git-line-h"></div>
//             </div>
//             <div className="git-text-wrap">
//                 <div className="git-text-stroke">Want Our Services?</div>
//             </div>
//             <div className="cross-wrap is-git">
//                 <div className="git-line-v"></div>
//                 <div className="git-line-h"></div>
//             </div>
//             <div className="git-text-wrap">
//                 <div className="git-text-stroke">Want Our Services?</div>
//             </div>
//         </div>
//     </div>
//     <div className="git-action-wrapper">
//         <div className="action is-git"><a href="/contact"
//                 className="btn w-inline-block">
//                 <div className="btn-text-wrap">
//                     <div className="btn-text-white">Get Connected</div>
//                     {/* <div className="btn-text-black-ab">Get Connected</div> */}
//                 </div>
//                 {/* <div className="whipe-white"></div> */}
//             </a></div>
//         <div className="whipe-yellow"></div>
//     </div>
// </section>
//   );
// }
